import React, { useEffect } from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import "../../assets/css/style.css";
import {
	AmericanMen,
	Etherium,
	Hat,
	NftNetwork,
	NftOwner,
} from "../../constant/Index";
import anime from "animejs/lib/anime.es.js";
import Brands from "./Brands";
import Video from "./Video";
import About from "./About";
import Features from "./Features";
import Nfts from "../../components/Nfts";
import Benefit from "../../components/Benefit";
import Faqs from "../../components/Faqs";
import { useSiteContentQuery } from "../../store/services/SitesettingService";
import { useNftsContentQuery } from "../../store/services/NftTypeService";
import { Link } from "react-router-dom";
import RoadMap from "../../components/RoadMap";
let ImgUrl = "https://lend-me-token.developer-ourbase-camp.com/uploads/";

const Home = () => {
	const { data, isLoading } = useSiteContentQuery();
	let response = data?.response?.data[0];
	const { data: nftData, isLoading: nftLoading } = useNftsContentQuery();
	let Nftresponse = nftData?.response?.data?.data;

	useEffect(() => {
		// Anime.Js
		var textWrapper = document.querySelector(".ml2");
		textWrapper.innerHTML = textWrapper.textContent.replace(
			/\S/g,
			"<span className='letter'>$&</span>",
		);

		anime
			.timeline({ loop: true })
			.add({
				targets: ".ml2 .letter",
				scale: [4, 1],
				opacity: [0, 1],
				translateZ: 0,
				easing: "easeOutExpo",
				duration: 950,
				delay: (el, i) => 70 * i,
			})
			.add({
				targets: ".ml2",
				opacity: 0,
				duration: 1000,
				easing: "easeOutExpo",
				delay: 1000,
			});
		// Anime.Js
	}, []);
	return (
		<>
			{/* Header */}
			<Header />
			{/* Header */}

			{/* Banner Sec Start Here */}
			<section className="banner_sec">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-5">
							<div className="content-wrapper">
								<div className="glowing">
									<span></span>
								</div>
								<div className="nft-network">
									<figure>
										<img
											src={NftNetwork}
											alt="nft-network"
											className="img-fluid"
										/>
									</figure>
								</div>
								<h5 className="wow animate__animated animate__zoomInLeft">
									WELCOME TO
								</h5>
								<h1 className="title wow animate__animated animate__zoomInLeft animate__delay-1s">
									{response?.section_one_title}
									<br />
									<span className="for-big ml2">
										{response?.section_one_heading}
									</span>
									<br />
									{response?.section_one_sub_heading}
								</h1>
								<p className="wow animate__animated animate__zoomInLeft animate__delay-2s">
									{response?.section_one_description}
								</p>
								<div className="button-group wow animate__animated animate__backInUp animate__delay-3s">
									<a href="#" className="buy-btn blue">
										<span className="txt">BUY NOW</span>
										<span className="svg-icon">
											<svg width="28" height="28" viewBox="0 0 28 28">
												<defs>
													<filter
														id="Ellipse_15"
														x="0"
														y="0"
														width="28"
														height="28"
														filterUnits="userSpaceOnUse"
													>
														<feOffset dy="2" input="SourceAlpha" />
														<feGaussianBlur stdDeviation="1" result="blur" />
														<feFlood floodOpacity="0.302" />
														<feComposite operator="in" in2="blur" />
														<feComposite in="SourceGraphic" />
													</filter>
												</defs>
												<g
													id="Group_27"
													data-name="Group 27"
													transform="translate(-340 -668)"
												>
													<g
														transform="matrix(1, 0, 0, 1, 340, 668)"
														filter="url(#Ellipse_15)"
													>
														<circle
															id="Ellipse_15-2"
															data-name="Ellipse 15"
															cx="11"
															cy="11"
															r="11"
															transform="translate(3 1)"
															fill="#f9f928"
														/>
													</g>
													<path
														id="Path_16"
														data-name="Path 16"
														d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
														transform="translate(-233.954 281.611)"
														fill="#d13900"
													/>
												</g>
											</svg>
										</span>
									</a>
									<a href="#" className="txt-btn">
										BORROW AGAINST NFTS
									</a>
								</div>
							</div>
						</div>
						<div className="col-lg-7">
							<div className="right-box">
								<div
									className="men-box layer wow animate__animated animate__zoomIn"
									data-speed="-5"
								>
									<div className="hat-circle">
										<figure>
											<img src={Hat} alt="nft-hat" className="img-fluid" />
										</figure>
									</div>
									<div className="american-men">
										<figure>
											<img
												src={AmericanMen}
												alt="american-men"
												className="img-fluid"
											/>
										</figure>
									</div>
								</div>
								<div className="join-box wow animate__animated animate__backInDown animate__delay-4s">
									<figure>
										<img src={NftOwner} alt="nft-owner" className="img-fluid" />
									</figure>
									<div className="txt">
										<h4>JOIN OUR EXCLUSIVe NFT COMMUNITY</h4>
										<p>
											Meet Crypto-legends, A-list celebrities, super-rich NFT
											collectors, and enthusiasts in our private NFT community.
										</p>
										<a href="#" className="buy-btn yellow">
											<span className="txt">BUY NOW</span>
											<span className="svg-icon">
												<svg
													width="17.949"
													height="17.949"
													viewBox="0 0 17.949 17.949"
												>
													<defs>
														<filter
															id="Ellipse_15"
															x="0"
															y="0"
															width="17.949"
															height="17.949"
															filterUnits="userSpaceOnUse"
														>
															<feOffset dy="2" input="SourceAlpha" />
															<feGaussianBlur stdDeviation="1" result="blur" />
															<feFlood floodOpacity="0.302" />
															<feComposite operator="in" in2="blur" />
															<feComposite in="SourceGraphic" />
														</filter>
													</defs>
													<g
														id="Group_27"
														data-name="Group 27"
														transform="translate(3 1)"
													>
														<g
															transform="matrix(1, 0, 0, 1, -3, -1)"
															filter="url(#Ellipse_15)"
														>
															<circle
																id="Ellipse_15-2"
																data-name="Ellipse 15"
																cx="5.975"
																cy="5.975"
																r="5.975"
																transform="translate(3 1)"
																fill="#3418fc"
															/>
														</g>
														<path
															id="Path_16"
															data-name="Path 16"
															d="M585.567,398.745a.351.351,0,0,1-.3-.344c0-.029,0-.058,0-.088q0-1.81,0-3.62a.641.641,0,0,1,.037-.228.34.34,0,0,1,.438-.186,1.263,1.263,0,0,1,.294.118q1.463.836,2.922,1.677a.656.656,0,0,1,.277.261.4.4,0,0,1-.142.507,1.137,1.137,0,0,1-.138.093l-2.916,1.676a1.084,1.084,0,0,1-.363.135Z"
															transform="translate(-580.75 -390.529)"
															fill="#f9f928"
														/>
													</g>
												</svg>
											</span>
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* Banner Sec End Here */}

			{/* Brands Sec Start Here */}
			{/* <Brands /> */}
			{/* Brands Sec End Here */}

			{/* Nft Video Sec Start Here */}
			<Video />
			{/* Nft Video Sec End Here */}

			{/* About Sec Start Here */}
			<About />
			{/* About Sec End Here */}

			{/* Feature Sec Start Here */}
			<Features />
			{/* Feature Sec End Here */}

			{/* Nft Collection Start Here */}
			{/* <section className="nft_collections">
				<div className="container">
					<div className="topbar-wrapper">
						<div className="heading-wrapper">
							<div className="glowing glowing-one">
								<span></span>
								<span></span>
							</div>
							<h4 className="wow animate__animated animate__fadeInLeft">
								LEND ME TOKEN
							</h4>
							<h2 className="wow animate__animated animate__fadeInLeft animate__delay-1s">
								OUR NFT COLLECTION
							</h2>
							<p className="wow animate__animated animate__fadeInLeft animate__delay-2s">
								For zero-risk and tamper-proof NFTs, we work on the Ethereum
								blockchain. Check out our unique NFT collections –common, rare,
								and super rare.
							</p>
						</div>
						<div className="button-group wow animate__animated animate__fadeInDown animate__delay-3s">
							<a href="#" className="buy-btn blue">
								<span className="txt">VIEW ALL</span>
								<span className="svg-icon">
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="28"
										height="28"
										viewBox="0 0 28 28"
									>
										<defs>
											<filter
												id="Ellipse_15"
												x="0"
												y="0"
												width="28"
												height="28"
												filterUnits="userSpaceOnUse"
											>
												<feOffset dy="2" input="SourceAlpha" />
												<feGaussianBlur stdDeviation="1" result="blur" />
												<feFlood floodOpacity="0.302" />
												<feComposite operator="in" in2="blur" />
												<feComposite in="SourceGraphic" />
											</filter>
										</defs>
										<g
											id="Group_27"
											data-name="Group 27"
											transform="translate(-340 -668)"
										>
											<g
												transform="matrix(1, 0, 0, 1, 340, 668)"
												filter="url(#Ellipse_15)"
											>
												<circle
													id="Ellipse_15-2"
													data-name="Ellipse 15"
													cx="11"
													cy="11"
													r="11"
													transform="translate(3 1)"
													fill="#f9f928"
												/>
											</g>
											<path
												id="Path_16"
												data-name="Path 16"
												d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
												transform="translate(-233.954 281.611)"
												fill="#d13900"
											/>
										</g>
									</svg>
								</span>
							</a>
						</div>
					</div>
					<div className="row">
						{Nftresponse?.slice(0, 4)?.map((nftdata, index) => {
							return (
								<div className="col-lg-3 col-md-6" key={index}>
									<div className="nft-box wow animate__animated animate__bounceIn mb-0">
										<a href={nftdata?.link} target="_blank">
											<div className="nft-image">
												<figure>
													<img
														src={`${ImgUrl}${nftdata?.image}`}
														alt=""
														className="img-fluid"
													/>
												</figure>
											</div>
											<div className="nft-content">
												<h4 className="name">{nftdata?.title}</h4>
												<div className="price">
													<figure>
														<img
															src={Etherium}
															alt="123"
															className="img-fluid"
														/>
													</figure>
													<h4>{nftdata?.price}</h4>
												</div>
											</div>
										</a>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</section> */}
			<RoadMap />
			{/* Nft Collection End Here */}

			{/* Benefit Sec Start Here */}
			<Benefit />
			{/* Benefit Sec End Here */}

			{/* <!-- FAQs Sec Start Here --> */}
			<section className="faqs_sec">
				<div className="container">
					<div className="row">
						<div className="col-lg-6">
							<div className="content-wrapper">
								<div className="glowing glowing-one">
									<span></span>
								</div>
								<h4 className="wow animate__animated animate__fadeInLeft">
									FREQUENTLY ASKED QUESTIONS
								</h4>
								<h2 className="wow animate__animated animate__fadeInLeft animate__delay-1s">
									POPULAR QUESTIONS
								</h2>
								<p className="wow animate__animated animate__fadeInLeft animate__delay-2s">
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt ut labore et dolore magnaor sit
									amet, con or sit amet, consectetur
								</p>
								<div className="button-group wow animate__animated animate__fadeInLeft animate__delay-3s">
									<a href="/faqs" className="buy-btn blue">
										<span className="txt">VIEW ALL</span>
										<span className="svg-icon">
											<svg width="28" height="28" viewBox="0 0 28 28">
												<defs>
													<filter
														id="Ellipse_15"
														x="0"
														y="0"
														width="28"
														height="28"
														filterUnits="userSpaceOnUse"
													>
														<feOffset dy="2" input="SourceAlpha" />
														<feGaussianBlur stdDeviation="1" result="blur" />
														<feFlood floodOpacity="0.302" />
														<feComposite operator="in" in2="blur" />
														<feComposite in="SourceGraphic" />
													</filter>
												</defs>
												<g
													id="Group_27"
													data-name="Group 27"
													transform="translate(-340 -668)"
												>
													<g
														transform="matrix(1, 0, 0, 1, 340, 668)"
														filter="url(#Ellipse_15)"
													>
														<circle
															id="Ellipse_15-2"
															data-name="Ellipse 15"
															cx="11"
															cy="11"
															r="11"
															transform="translate(3 1)"
															fill="#f9f928"
														/>
													</g>
													<path
														id="Path_16"
														data-name="Path 16"
														d="M585.823,402.516a.646.646,0,0,1-.556-.634c0-.054,0-.107,0-.161q0-3.333,0-6.665a1.178,1.178,0,0,1,.069-.419.626.626,0,0,1,.806-.343,2.325,2.325,0,0,1,.541.217q2.694,1.538,5.38,3.087a1.207,1.207,0,0,1,.509.48.736.736,0,0,1-.262.933,2.108,2.108,0,0,1-.255.17l-5.37,3.085a1.994,1.994,0,0,1-.669.249Z"
														transform="translate(-233.954 281.611)"
														fill="#d13900"
													/>
												</g>
											</svg>
										</span>
									</a>
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<Faqs />
						</div>
					</div>
				</div>
			</section>
			{/* <!-- FAQs Sec End Here --> */}

			{/* Footer */}
			<Footer />
			{/* Footer */}
		</>
	);
};

export default Home;
